import smoothScroll from 'smooth-scroll'

export const onInitialClientRender = () => {
  smoothScroll('a[href*="#"]')
}
